import parse, { domToReact } from 'html-react-parser';
import { Props } from '../types/types';

import {useUserStore} from '../store/user';

import EmailForm from '../Components/EmailForm';
import PageSignup from './PageSignup';
import AppChapters from './AppChapters';
import AppChapter from './AppChapter';
import AppQuestion from './AppQuestion';
import { WpPage } from '../App';
import { Touchable} from '../libs/WebComponents';
import { Page } from './Pager';


export const parsePostContent = (props:{content: string, goTo: Function, index: number, firstname: string,removePopup?: Function}) => {
   let body = props.content;
   const {firstname} = useUserStore.getState();

   body = body.replaceAll('[firstname]', firstname);
   body = body.replaceAll('[form_email]', '<form id="form_email"/>');
   body = body.replaceAll('&\#8221;','”');

   // Regexp om de waarden van 'label' en 'steps' te extraheren met capture groups
   for (let regex of [
      /\[next-page(?: label="([^"]*)")?(?: steps=([0-9]+))?\]/,
      /\[next-page(?: label=”([^”]*)”)?(?: steps=([0-9]+))?\]/
   ]){
      //const regex = /\[next-page(?: label="([^"]*)")?(?: steps=([0-9]+))?\]/;

      // De match-methode gebruiken om de waarden te vinden
      let match: any;
      while (match = body.match(regex)){

         if (match) {
            // De eerste capture group bevat de waarde van 'label' (indien aanwezig)
            let label = match[1] || "Ga door";
            
            // De tweede capture group bevat de waarde van 'steps' (indien aanwezig)
            let steps = match[2] || 1;

            body = body.replace(regex, '<button id="next-page-skip" steps="'+Number(steps)+'">'+label+'</button>');
         }
      }
   }

   const children = parse(body,{
      replace(domNode: any) {
         if (!domNode.attribs) return;
         if (domNode.attribs.id === 'form_email'){
            return <EmailForm />;
         }

         if (domNode.attribs.href === '#next-page') {
            domNode.attribs.href = null;
            return <Touchable onPress={()=>props.goTo(props.index+1)}>{domToReact([domNode])}</Touchable>;
         }
         if (domNode.attribs.id === 'next-page-skip') {
            const steps = parseInt(domNode.attribs.steps);
            return <a href={"#next"} onClick={()=>{props.goTo(props.index+steps);props.removePopup && props.removePopup();return false}} style={{textDecoration:'underline',cursor:'pointer'}}>{domNode.children[0].data}</a>;
         }
      },
   });
   return children;
};

const parsePage = (page: WpPage, props: Props): JSX.Element=>{


   if (page.post_name==='app-signup') {
      return <PageSignup key={page.ID} index={props.index} goTo={props.goTo} prevPage={props.prevPage} group={props.group}/>;
   }else if (page.post_name==='app-chapters') {
      return <AppChapters {...props} key={page.ID} />;
   }else if (page.page_type==='chapter') {
      return <AppChapter {...props} page={page} key={page.ID} />;
   }else if (page.page_type==='question') {
      return <AppQuestion {...props} page={page} key={page.ID} />;
   }else{
      const children = parsePostContent({content:page.post_content, firstname:props.firstname, goTo:props.goTo, index:props.index});

      return <Page {...props}>{children}</Page>;
   }
};

export default parsePage;